'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lpresto_AuditPage$() {
}
export { $c_Lpresto_AuditPage$ as $c_Lpresto_AuditPage$ };
$p = $c_Lpresto_AuditPage$.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_AuditPage$;
/** @constructor */
function $h_Lpresto_AuditPage$() {
}
export { $h_Lpresto_AuditPage$ as $h_Lpresto_AuditPage$ };
$h_Lpresto_AuditPage$.prototype = $p;
$p.dw = (function() {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_None$();
});
$p.x = (function() {
  return new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_Product$$anon$1(this);
});
$p.p = (function() {
  return (-2098320150);
});
$p.l = (function() {
  return "AuditPage";
});
$p.r = (function() {
  return 0;
});
$p.s = (function() {
  return "AuditPage";
});
$p.j = (function(n) {
  throw $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
var $d_Lpresto_AuditPage$ = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_AuditPage$, "presto.AuditPage$", ({
  Ep: 1,
  a2: 1,
  b: 1,
  c: 1,
  a: 1,
  e: 1,
  g: 1,
  m: 1
}));
export { $d_Lpresto_AuditPage$ as $d_Lpresto_AuditPage$ };
var $n_Lpresto_AuditPage$;
function $m_Lpresto_AuditPage$() {
  if ((!$n_Lpresto_AuditPage$)) {
    $n_Lpresto_AuditPage$ = new $c_Lpresto_AuditPage$();
  }
  return $n_Lpresto_AuditPage$;
}
export { $m_Lpresto_AuditPage$ as $m_Lpresto_AuditPage$ };
//# sourceMappingURL=presto.-Audit-Page$.js.map
